import React, { forwardRef } from 'react';
import { InputSC } from './input.styled';
import XIcon from '@common/assets/svg/x.svg';

type TProps = {
  variation?: 'lined' | 'round' | 'table';
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  error?: React.ReactNode;
  clearable?: true;
  handleClearableClick?: () => void;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Input = (
  {
    error,
    variation = 'lined',
    clearable,
    handleClearableClick,
    ...rest
  }: TProps,
  ref?: React.Ref<HTMLInputElement>,
) => {
  return (
    <InputSC error={error} variation={variation} className={'input-root'}>
      {rest.prefix && <span>{rest.prefix}</span>}
      <input {...rest} autoComplete="off" ref={ref} />
      {clearable ? (
        <div className={'clear-icon'} onClick={handleClearableClick}>
          <img src={XIcon} alt={'clear-icon'} />
        </div>
      ) : null}
      {rest.suffix && <span>{rest.suffix}</span>}
    </InputSC>
  );
};

export default forwardRef(Input);
